import React from 'react';
import ShoppingList from './ShoppingList'
import OrderMeals from './OrderMeals'
import { createMaterialTopTabNavigator } from 'react-navigation-tabs';
import { NavigationTabs } from '../../ui';
import Nutrition1Day from '../Nutrition1Day';

const recipeTab = {
    title: 'Recipes',
    tab: {
        screen: Nutrition1Day,
        navigationOptions: {
            tabBarLabel: 'Recipes',
        }
    }
};

const shoppingListTab = {
    title:'Shopping List',
    tab: {
        screen: ShoppingList,
        navigationOptions: {
            tabBarLabel: 'Shopping List',
        }
    }
};

const orderTab = {
    title: 'Order Meals',
    tab: {
        screen: OrderMeals,
        navigationOptions: {
            tabBarLabel: 'Order Meals',
        }
    }};


const nutritionWithoutOrderMeals = {
    [recipeTab.title]: recipeTab.tab,
    [shoppingListTab.title]: shoppingListTab.tab
}

const nutritionWithOrderMeals = {
    [recipeTab.title]: recipeTab.tab,
    [shoppingListTab.title]: shoppingListTab.tab,
    [orderTab.title]: orderTab.tab
}

const nutritionTopTabProperties = {
    lazy: true,
    swipeEnabled: true,
    backBehavior: 'none',
    tabBarPosition: 'top',
    tabBarComponent: tabBarProps => (
        <NavigationTabs {...tabBarProps} />
    ),
};

export const NutritionTabNavigationWithOrderMeal = createMaterialTopTabNavigator({
    ...nutritionWithOrderMeals
}, nutritionTopTabProperties);

export const NutritionTabNavigationWithoutOrderMeal = createMaterialTopTabNavigator({
    ...nutritionWithoutOrderMeals
}, nutritionTopTabProperties);
